export type ToastStatus = "success" | "error" | "warning" | "info";

export interface ToastConf {
  duration: number;
  status: ToastStatus;
}

const baseConf: Omit<ToastConf, "status"> = {
  duration: 9000,
};

export const toastSuccess: ToastConf = {
  status: "success",
  ...baseConf,
};

export const toastError: ToastConf = {
  status: "error",
  ...baseConf,
};

export const toastWarning: ToastConf = {
  status: "warning",
  ...baseConf,
};

export default baseConf;
